import { memo } from 'react'

import * as Styled from '../styled'

import DeleteIcon from 'assets/svgr-icons/Remove.svg'

import Tooltip from 'components/Tooltip'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import Icon from 'common-components/Icon'

interface IProps {
  onDeleteIconClick: (id: number) => void
  id: number
}

const SoundListItemDeleteButton: React.FC<IProps> = ({
  onDeleteIconClick,
  id
}) => {
  return (
    <Tooltip tooltipText={translate(T.DELETE_LABEL)}>
      <Styled.IconButtonWrapper
        onClick={() => {
          onDeleteIconClick(id)
        }}
      >
        <Icon icon={<DeleteIcon />} size="small" color="secondarySemiDark" />
      </Styled.IconButtonWrapper>
    </Tooltip>
  )
}

export default memo(SoundListItemDeleteButton)
